/* eslint-disable @typescript-eslint/no-unused-vars */
import { Theme } from "@mui/material";
import { TrendingUpIcon } from "lucide-react";
import { formatFullDate, formatTimeAgo } from "./dateUtils";
import { ACTION_RESULT_LABELS } from "../../../utils/workItemUtils";
import { differenceInCalendarDays, format, formatDistanceToNow, isPast, isToday } from "date-fns";

import { sv } from "date-fns/locale";

// Get trend icon based on login trend - only show upward trends
export const getTrendIcon = (trend: "up" | "down" | "neutral" | null) => {
  if (trend === "up") {
    return <TrendingUpIcon fontSize="small" color="success" />;
  }
  return null;
};

// Get trend description text - only for upward trends
export const getTrendDescription = (
  trend: "up" | "down" | "neutral" | null
) => {
  if (trend === "up") {
    return "Ökande inloggningsfrekvens";
  }
  return "";
};

// Function to get chip color based on segment importance (first character)
export const getChipColor = (segment: string | null, theme: Theme) => {
  if (!segment || segment.length === 0) return theme.palette.grey[500]; // Default color if no segment
  // Extract importance level (first character)
  const importanceLevel = segment.charAt(0);

  switch (importanceLevel) {
    case "A":
      return theme.palette.success.main; // Highest importance - green
    case "B":
      return theme.palette.warning.main; // Medium importance - amber/orange
    case "C":
      return theme.palette.error.main; // Lower importance - red
    default:
      return theme.palette.grey[500]; // Default - gray
  }
};

// Extract segment importance (letter) from segment code
export const getSegmentImportance = (segment: string | null): string | null => {
  if (!segment || segment.length === 0) return null;
  return segment.charAt(0);
};

// Extract segment size (number) from segment code
export const getSegmentSize = (segment: string | null): string | null => {
  if (!segment || segment.length < 2) return null;
  const size = segment.charAt(1);
  return /\d/.test(size) ? size : null; // Make sure it's a digit
};
// Format the time as "X dag(ar) sedan" - fall back to -- if null
export const formatTime = (date: string | null) => {
  if (!date) return "--";

  try {
    const inputDate = new Date(date);

    if (isToday(inputDate)) {
      return `Idag ${format(inputDate, 'HH:mm')}`;
    }

    if (isPast(inputDate)) {
      const diffDays = differenceInCalendarDays(new Date(), inputDate);
      return diffDays === 1 ? "1 dag sedan" : `${diffDays} dagar sedan`;
    }

    return `om ${formatDistanceToNow(inputDate, { locale: sv })}`;
  } catch (e) {
    return "--";
  }
};
